import ParentClass from './Parent.js';

class ValidationService extends ParentClass {
  constructor() {
    super();
    const moduleClass = '.validation-service';
    if(!super.runThisModule(moduleClass)) return;
    this.showCapability();
  }


  showCapability() {
    const columns   = $('.capability-container');
    const link      = columns.find('.icon-toggle,.topline');
    const target    = $('.capability-description');
    const title     = $('.topline');

    link.click(function(e){
      e.preventDefault();
      let $this = $(this);
      let description = $this.parent().find('.description-data').html();
      let speed = 300;
      let container = $(this).parents('.capability-row');
      let column = $(this).closest('.capability-container');
      let thisTitle = $(this).parent().find('.topline');
      var thisTarget = container.next(target);
      var mobile = false;

      if ($('.capability-wrapper-mobile').css('display') === 'block') {
        mobile = true;
      }

      if ($this.hasClass('active') === true) {
        $this.removeClass('active');
        title.removeClass('active');
        columns.removeClass('active');
        thisTarget.slideUp(speed).addClass('active');
      } else if (link.hasClass('active') === false) {
        $this.addClass('active');
        thisTitle.addClass('active');
        column.addClass('active');
        thisTarget.html(description).slideDown(speed, function() {
          $('html, body').animate({
            scrollTop: (thisTarget.offset().top - 200)
          },500);
        });
      } else {
        link.removeClass('active');
        title.removeClass('active');
        columns.removeClass('active');
        if (mobile) {
          target.slideUp(speed, function() {
            $this.addClass('active');
            thisTitle.addClass('active');
            column.addClass('active');
          });
          thisTarget.html(description).delay(200).slideDown(speed, function() {
            $('html, body').animate({
              scrollTop: (thisTarget.offset().top - 200)
            },500);
          });
        } else {
          target.slideUp(speed, function() {
            $this.addClass('active');
            thisTitle.addClass('active');
            column.addClass('active');
            thisTarget.html(description).delay(200).slideDown(speed, function() {
              $('html, body').animate({
                scrollTop: (thisTarget.offset().top - 200)
              },500);
            });
          });
        }
      }
    });
  }
}


jQuery(document).ready(function() {
  new ValidationService();
});



// WEBPACK FOOTER //
// ./wp-content/themes/variscale/library/js/classes/ValidationService.js